import * as React from 'react';
import './MyMessage.sass';
import {Avatar} from '../Avatar/Avatar';
import {Icon} from '@iconify/react';
import TextareaAutosize from 'react-textarea-autosize';
import {useSelector} from 'react-redux';
import {RootState} from '../../Redux/store';
import {auth, db} from '../../Firebase/main';
import {isUserId} from '../../Users';


export interface IMyMessageProps {
    message: string;
    avatar?: string;
    online?: boolean;
    edited?: boolean;
    id: number;

}


export const MyMessage: React.FC<IMyMessageProps> = (props) => {

    // const [messageSettings, showMessageSettings] = React.useState<boolean>(false);
    const [editingMode, setEditingMode] = React.useState<boolean>(false);
    const [editedMessage, setEditedMessage] = React.useState<string>('');

    const {selectedId} = useSelector((state: RootState) => state.main);


    function catchEnterKey(e: any) {
        if (!e.shiftKey && e.key === 'Enter') {
            e.preventDefault();
            handleSend();
        }
        if (e.key === 'Escape') {
            setEditingMode(false);
            setEditedMessage('');
        }
    }


    async function handleSend() {
        const myId = auth.currentUser?.uid;
        try {
            if (editedMessage && editedMessage !== props.message && myId) {
                if (isUserId(selectedId)) {
                    await db.ref(`private_messages/${selectedId}/${myId}/${props.id}`).update({
                        message: editedMessage, edited: true,
                    });
                    await db.ref(`private_messages/${myId}/${selectedId}/${props.id}`).update({
                        message: editedMessage, edited: true,
                    });
                }
                else {
                    await db.ref(`public_messages/${selectedId}/${props.id}`).update({
                        message: editedMessage, edited: true,
                    });
                }

            }
        } catch (e) {
            console.log(e.message);
        }
        setEditedMessage('');
        setEditingMode(false);
    }


    async function handleDelete() {
        const myId = auth.currentUser?.uid;
        try {
            if (isUserId(selectedId)) {
                await db.ref(`private_messages/${selectedId}/${myId}/${props.id}`).remove();
                await db.ref(`private_messages/${myId}/${selectedId}/${props.id}`).remove();
            }
            else {
                await db.ref(`public_messages/${selectedId}/${props.id}`).remove();
            }
        } catch (e) {
            console.log(e.message);
        }
    }


    return (
        <div className={'my-message'}>
            <Avatar
                uri={props.avatar}
                online={props.online}
                size={24}
                style={{marginLeft: 8}}
            />

            {editingMode ?
                <span className={'my-message-input'}>
                    <span className={'my-message-input-esc-icon'} onClick={() => setEditingMode(false)}>esc</span>
                    <TextareaAutosize
                        autoFocus={true}
                        key={'input'}
                        className={'my-message-input-text'}
                        defaultValue={props.message}
                        onChange={(e) => setEditedMessage(e.target.value)}
                        onKeyDown={catchEnterKey}
                        onBlur={() => setEditingMode(false)}
                    />

                    <Icon
                        key={'icon'}
                        onClick={() => {}}
                        className={'my-message-input-send-icon'}
                        icon={'fluent:arrow-enter-left-20-filled'}
                        height={14}
                        color={'#404040'}
                    />
                </span>
                : <div className={'my-message-text'}>
                    <div>{props.message}</div>
                </div>
            }

            <div className={'my-message-settings'}>
                <Icon onClick={() =>
                    setEditingMode(true)
                }
                      className={'my-message-settings-edit-icon'}
                      icon={'clarity:edit-solid'} height={14}/>

                <Icon onClick={handleDelete} className={'my-message-settings-delete-icon'}
                      icon={'fluent:delete-24-filled'} height={14}/>
                {props.edited && <span className={'edited-indicator'}>(edited)</span>}
            </div>
        </div>
    );
};